"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover.default;
  }
});

var _Popover = _interopRequireDefault(require("./Popover"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Popover/index.js
// module id = 743
// module chunks = 0